import React from 'react';

function Landing() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-4xl font-bold mb-6">Automate Your Mortgage Leads with AI</h1>
      <p className="mb-4">Home Lead IQ helps mortgage pros capture and follow up with leads directly from Facebook conversations using AI-powered automation.</p>
      <ul className="list-disc pl-5 mb-6">
        <li>✅ Facebook group lead capture</li>
        <li>✅ Google Calendar integration</li>
        <li>✅ Smart follow-up with email/text</li>
        <li>✅ Secure lead storage dashboard</li>
      </ul>
      <a href="/chat" className="text-blue-600 underline">Try the demo</a>
    </div>
  );
}

export default Landing;